var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 18.9583H4.16699C2.44199 18.9583 1.04199 17.5583 1.04199 15.8333V1.66667C1.04199 1.32501 1.32533 1.04167 1.66699 1.04167C2.00866 1.04167 2.29199 1.32501 2.29199 1.66667V15.8333C2.29199 16.8667 3.13366 17.7083 4.16699 17.7083H18.3337C18.6753 17.7083 18.9587 17.9917 18.9587 18.3333C18.9587 18.675 18.6753 18.9583 18.3337 18.9583Z",
    fill: "#00A79D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16684 14.7917C4.02518 14.7917 3.87518 14.7417 3.75851 14.6417C3.50018 14.4167 3.46684 14.025 3.69184 13.7583L7.51684 9.29167C7.93351 8.80833 8.53351 8.51667 9.16684 8.49167C9.80018 8.475 10.4252 8.70833 10.8752 9.15833L11.6668 9.95C11.8752 10.1583 12.1418 10.2583 12.4418 10.2583C12.7335 10.25 13.0002 10.1167 13.1918 9.89167L17.0168 5.425C17.2418 5.16667 17.6335 5.13333 17.9002 5.35833C18.1585 5.58333 18.1918 5.975 17.9668 6.24167L14.1418 10.7083C13.7252 11.1917 13.1252 11.4833 12.4918 11.5083C11.8502 11.525 11.2335 11.2917 10.7835 10.8417L10.0002 10.05C9.79184 9.84167 9.51684 9.73333 9.22518 9.74167C8.93351 9.75 8.66684 9.88333 8.47518 10.1083L4.65018 14.575C4.51684 14.7167 4.34184 14.7917 4.16684 14.7917Z",
    fill: "#00A79D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line-chart.197509213d017c0f17d44c56294a525a.svg";
export { ForwardRef as ReactComponent };